import DateRangeInputControl from "controls/dateRangeInput";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FilterView from "../../common/filter";
import type SubLedgerListViewModel from "../../../viewModels/finance/subLedger/SubLedgerListViewModel";

export interface SubLedgerListFiltersProps {
  vm: SubLedgerListViewModel;
}

const SubLedgerListFilters = observer((props: SubLedgerListFiltersProps) => {
  const { vm } = props;
  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateFilterAttribute("createdDate")}</Form.Label>
          <DateRangeInputControl target={vm.filter} property="createdDate" />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default SubLedgerListFilters;
